import lodashPick from 'lodash/fp/pick';

import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';

const getPinnedListingsQueryParams = lodashPick(['bedrooms', 'marketId']);

export default async function getPinnedListings({ state, apiClient }) {
  if (state.get(['noResultsPinnedListings'])) {
    return;
  }

  const pinnedListings = await apiClient.post(SR_API_ACTION_GET_LISTING_LIST, {
    page: 0,
    count: 60,
    filters: {
      ...getPinnedListingsQueryParams(state.get(['currentUser', 'searchFilters'])),
      pinned: true,
    },
    sort: [],
  });

  state.set(['noResultsPinnedListings'], pinnedListings.data);
  state.commit();
}
